import { JSX, ReactNode, createContext, useContext } from 'react';
import { SubmitUserSettingsRequest, UserSettingsResponse, Timezone } from 'vopay';
import useUserSettings from '@/hooks/useApi/useUserSettings';

type UserSettings = {
  userSettings: { timezone: Timezone };
  submitUserSettings: (userSettings: SubmitUserSettingsRequest) => Promise<UserSettingsResponse>;
};

export const UserSettingsContext = createContext<UserSettings>({
  userSettings: {
    timezone: 'UTC',
  },
  submitUserSettings: async () => ({
    Success: false,
    ErrorMessage: '',
    Username: '',
    Settings: {
      timezone: 'UTC',
    },
  }),
});

export const UserSettingsProvider = ({ children }: { children: ReactNode }): JSX.Element => {
  const { userSettings, submitUserSettings } = useUserSettings();

  return (
    <UserSettingsContext.Provider
      value={{
        userSettings,
        submitUserSettings,
      }}
    >
      {children}
    </UserSettingsContext.Provider>
  );
};

export const useUserSettingsProvider = (): UserSettings => useContext(UserSettingsContext);
